import { render, staticRenderFns } from "./addrisAssessment.vue?vue&type=template&id=76b2dbc2&scoped=true&"
import script from "./addrisAssessment.vue?vue&type=script&lang=js&"
export * from "./addrisAssessment.vue?vue&type=script&lang=js&"
import style0 from "./addrisAssessment.vue?vue&type=style&index=0&id=76b2dbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2dbc2",
  null
  
)

export default component.exports